import { FC } from "react";
import {
  ReportCustomersTransactionAndAcTransactionSearchPanel,
  ReportPage,
} from "../../../components";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import { SearchReportSuppliersTransactionAndAcTransactionPage } from "../../../serviceBroker/customersReportApiServiceBroker";
import {
  CustomersTransactionAndAcTransactionSearchParamsModel,
  PageEnum,
} from "../../../models";

export const ReportSuppliersTransactionAndAcTransactionPage: FC = () => {
  const initialState: CustomersTransactionAndAcTransactionSearchParamsModel = {
    Lang: getSystemLanguageId(),
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={SearchReportSuppliersTransactionAndAcTransactionPage}
      searchHeader={getPageNameByPageId(
        PageEnum.ReportAllSuppliersTransactions
      )}
      SearchPanel={ReportCustomersTransactionAndAcTransactionSearchPanel}
      formId={PageEnum.ReportAllSuppliersTransactions}
    />
  );
};
